import React from "react";
import { useNavigate } from "react-router-dom";
import { X } from "lucide-react";

const CongratulationsModal = ({ onClose }) => {
  const navigate = useNavigate();

  const handleStartTranslating = () => {
    if (onClose) onClose();
    navigate("/user-dashboard/translation");
  };

  const handleViewPricing = () => {
    if (onClose) onClose();
    navigate("/user-dashboard/upgrade-plan");
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white border border-[#e0e4e2] rounded-[16px] w-full max-w-[558px] max-h-[90vh] overflow-y-auto px-6 md:px-[38px] py-8 md:py-[40px] flex items-center justify-center relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 p-2 text-[#7e726b] hover:text-[#1d2129] transition-colors duration-200"
          aria-label="Close modal"
        >
          <X size={24} />
        </button>
        <div className="w-full flex flex-col gap-6 md:gap-[24px]">
          {/* Icon Section */}
          <div className="flex flex-col items-center gap-8 md:gap-[32px]">
            <div className="w-[90px] h-[90px] rounded-full bg-[#FFEEC2] flex items-center justify-center">
              <span className="text-[45px] leading-[45px]">🎉</span>
            </div>
          </div>

          {/* Text Section */}
          <div className="flex flex-col items-center gap-2 md:gap-[8px] text-center">
            <h1 className="text-2xl md:text-[28px] leading-tight md:leading-[28px] font-black text-[#1d2129] m-0">
              You have received free tokens!
            </h1>

            <p className="text-sm md:text-[16px] leading-6 md:leading-[28px] font-normal text-[#7e726b] m-0">
              You've been given 50 free trial tokens to try NKENNEAi for 7 days. Start
              translating now or view pricing plans anytime to upgrade.
            </p>
          </div>

          {/* Actions Section */}
          <div className="flex flex-col gap-4 md:gap-[16px]">
            {/* Primary Button */}
            <button
              onClick={handleStartTranslating}
              className="w-full h-[46px] bg-[#1e6b56] rounded-[16px] px-4 md:px-[77px] flex items-center justify-center font-bold text-[16px] leading-[26.32px] text-white transition-colors duration-200 hover:bg-[#1a5d4a] active:bg-[#164f3f]"
            >
              Start translating
            </button>

            {/* Secondary Button */}
            <button
              onClick={handleViewPricing}
              className="w-full h-[46px] border border-[#e0e4e2] rounded-[16px] px-4 md:px-[77px] flex items-center justify-center font-bold text-[16px] leading-[26.32px] text-[#1e6b56] bg-transparent transition-all duration-200 hover:bg-[#f8f9fa] hover:border-[#d0d4d2] active:bg-[#e9eceb]"
            >
              View pricing plans
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CongratulationsModal;
